// =============================================================================
// components/ui/Asset3D.tsx — premium 3D brand objects (Higgsfield/Recraft).
//
// Single glossy material family, CRYB purple, transparent cutouts so they sit on
// any surface (gradient, glass, card). Drop one into empty states, hero moments,
// gamification and success states to give CRYB the premium crypto-app feeling.
// Only assets referenced here are bundled — add more from assets/brand/3d as used.
// =============================================================================
import React from 'react';
import { Image, StyleProp, ImageStyle } from 'react-native';

// Transparent (background-removed) 3D assets — the full brand set.
const ASSETS = {
  orb: require('../../assets/brand/3d/orb-signature.png'),
  emptyCluster: require('../../assets/brand/3d/empty-cluster.png'),
  chat: require('../../assets/brand/3d/chat-bubble.png'),
  bell: require('../../assets/brand/3d/bell.png'),
  compass: require('../../assets/brand/3d/compass.png'),
  trophy: require('../../assets/brand/3d/trophy.png'),
  learn: require('../../assets/brand/3d/learn.png'),
  community: require('../../assets/brand/3d/community.png'),
  error: require('../../assets/brand/3d/error.png'),
  success: require('../../assets/brand/3d/success.png'),
  gem: require('../../assets/brand/3d/gem.png'),
  coin: require('../../assets/brand/3d/coin-eth.png'),
  coinBtc: require('../../assets/brand/3d/coin-btc.png'),
  coinStack: require('../../assets/brand/3d/coin-stack.png'),
  token: require('../../assets/brand/3d/token.png'),
  card: require('../../assets/brand/3d/card.png'),
  chart: require('../../assets/brand/3d/chart.png'),
  wallet: require('../../assets/brand/3d/vault.png'),
  vault: require('../../assets/brand/3d/vault.png'),
  shield: require('../../assets/brand/3d/shield.png'),
  key: require('../../assets/brand/3d/key.png'),
  diamond: require('../../assets/brand/3d/diamond.png'),
  medal: require('../../assets/brand/3d/medal.png'),
  gift: require('../../assets/brand/3d/gift.png'),
  rocket: require('../../assets/brand/3d/rocket.png'),
  heart: require('../../assets/brand/3d/heart.png'),
  chain: require('../../assets/brand/3d/chain.png'),
  network: require('../../assets/brand/3d/network-orb.png'),
  avatar: require('../../assets/brand/3d/avatar-orb.png'),
} as const;

export type Asset3DName = keyof typeof ASSETS;

export default function Asset3D({
  name,
  size = 128,
  style,
}: {
  name: Asset3DName;
  size?: number;
  style?: StyleProp<ImageStyle>;
}) {
  return (
    <Image
      source={ASSETS[name]}
      // alignSelf center by default so the asset never sits left-of-center inside
      // a GlassCard/empty-state whose inner container isn't centering (callers can
      // still override via `style`). Fixes off-center empty-state icons app-wide.
      style={[{ width: size, height: size, alignSelf: 'center' }, style]}
      resizeMode="contain"
      accessible={false}
    />
  );
}
